import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonMessage } from '../../../enums/message';


@Component({
  selector: 'app-home-detail',
  templateUrl: './home-detail.component.html',
  styleUrl: './home-detail.component.scss'
})
export class HomeDetailComponent {

  myRegistrationDetail:any;
  constructor( private router: Router,
    private activeRoute: ActivatedRoute
   ) {
  }
    
  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe(params => {
    const formId = params['formId'];
        if(formId){
            
        }
    });
  }

  public backToHome() {
    this.router.navigateByUrl('/');  
  }
  getAnswerForField(fieldId: number, values: any[]): string | null {
    const valueEntry = values?.find((v) => v.fieldId === fieldId);
    return valueEntry?.value?.answer ?? null;
  }
}
